/** Grade responsiva compartilhada pela seção e pelo skeleton. */
export const AGENT_SHORTS_GRID_CLASS =
	'grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-5 lg:grid-cols-4';

/** Proporção vertical usada pelos cards no handoff da página de corretor. */
export const AGENT_SHORTS_CARD_CLASS =
	'aspect-9/14 h-auto rounded-none md:aspect-[197/285] motion-reduce:animate-none';

/** O skeleton cobre exatamente a primeira página da grade. */
export const AGENT_SHORTS_SKELETON_COUNT = 8;
